define('shoptheme/components/blocks/captcha',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
], function(
	$,
	_,
	Component,
	BEM
) {

	function Captcha(block) {
		this.block = BEM.block(block);
		this.bindEvents();
	}

	Captcha.prototype = {
		block: null,

		bindEvents: function() {
			var self = this;

			this.block.on('click', '[data-action="refresh"]', function(e) {
				var trigger = $(this),
					isButton = trigger.is('button') || trigger.hasClass('btn');

				e.preventDefault();

				if (isButton) {
					trigger.button("loading");
					trigger.attr("disabled", true);
				}

				self.reload().always(function() {
					trigger.button("reset");
					trigger.attr("disabled", false);
				});
			});
		},

		reload: function() {
			var deferred = $.Deferred();
			var url = this.block.data('refresh-url');
			var self = this;

			if (!url) {
				deferred.reject();
			} else {
				$.post(url).done(function(data) {
					try {
						self._insertData(data);
					} catch (ex) {
						deferred.reject();
						return;
					}

					deferred.resolve(data);
				}).fail(function() {
					deferred.reject();
				});
			}

			return deferred.promise();
		},

		_insertData: function(data) {
			this.block.find('[name="captcha[id]"]').val(data.id);
			this.block.getElements('image').find('img').attr('src', ['data:image/png;base64,', data.image].join(""));
		}
	};


	return Component.create({
		blocks: null,

		$init: function() {
			this.blocks = BEM.block('captcha');
			this.blocks.each(function() {
				var block = BEM.block(this);
				new Captcha(block);
			});
		}
	});
});
